/**
 * @generated SignedSource<<1c0759b364a6890ded896701bb942cb0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topicDropdown_AtlassianHubAppShell$data = {
  readonly topicPages: ReadonlyArray<{
    readonly id: string;
    readonly name: {
      readonly default: string;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "topicDropdown_AtlassianHubAppShell";
};
export type topicDropdown_AtlassianHubAppShell$key = {
  readonly " $data"?: topicDropdown_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicDropdown_AtlassianHubAppShell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topicDropdown_AtlassianHubAppShell",
  "selections": [
    {
      "alias": "topicPages",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "ids": [],
            "type": "TOPIC"
          }
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "default"
            }
          ]
        }
      ],
      "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "9aa0d54a463ddf69b87af168a98c5079";

export default node;
